'use client';

import { PageContent } from '@stereoagency/ui';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export default function Content({ children }: Props) {
  return <PageContent className="min-h-full mb-0 md:mb-0">{children}</PageContent>;
}
